import Vue from 'vue'
import Router from 'vue-router'
const Layout = () =>
  import("@/views/layout/layout_horizontal");
const Layout1 = () =>
  import("@/views/layout/layout2");

const InnerLayout = () =>
import("@/views/layout/inner_layout");

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

export const constantRouterMap = [
  {
    path: '/404',
    component: () =>
      import('@/views/errorPage/404'),
    hidden: true
  },
  {
    path: '/',
    component: Layout1,
    redirect: '/home',
    hidden: true
  },
  {
    path: '/jump',
    hidden: true,
    component: InnerLayout,
    children: [{
      path: 'jump',
      component: () =>
        import("@/views/home/jump"),
      name: 'jump'
    }]
  },
  {
    path: '/home',
    component: Layout,
    redirect: '/home/home',
    meta: {
      title: '首页'
    },
    children: [
      {
        path: 'home',
        component: () =>
          import("@/views/home/home"),
        name: 'home',
        meta: {
          title: '首页',
          icon: 'home'
        }
      }
    ]
  }
  , {
    path: '/news',
    component: Layout,
    redirect: '/news/new',
    meta: {
      title: '新闻中心',
      // icon: 'el-icon-tickets',
      rid: ""
    },
    children: [{
      path: 'new',
      component: () =>
        import("@/views/news/new"),
      name: 'new',
      meta: {
        title: '新闻动态',
        icon: '',
        rid: "-1",
        keepAlive: true
      }
    }, {
      path: 'local',
      component: () =>
        import("@/views/news/local"),
      name: 'local',
      meta: {
        title: '地方要闻',
        icon: '',
        rid: "-1",
        keepAlive: true
      }
    },
      // {
      //   path: 'policy',
      //   component: () =>
      //     import("@/views/news/policy"),
      //   name: 'policy',
      //   meta: {
      //     title: '政策新闻',
      //     icon: '',
      //     rid: "-1",
      //     keepAlive: true
      //   }
      // },
    ]
  }
  , {
    path: '/zxAll',
    component: Layout,
    redirect: '/zxAll/zxAll',
    meta: {
      title: '新闻中心',
      // icon: 'el-icon-tickets',
      rid: "",
      hidden: true
    },
    children: [{
      path: 'zxAll/:gjz/:date',
      component: () =>
        import("@/views/zxAll/zxAll"),
      name: 'zxAll',
      meta: {
        title: '咨询管理',
        icon: '',
        rid: "-1",
        // keepAlive: true
      }
    }, {
      path: 'gyAll/:gjz/:date',
      component: () =>
        import("@/views/zxAll/gyAll"),
      name: 'gyAll',
      meta: {
        title: '供应项目',
        icon: '',
        rid: "-1",
        keepAlive: true
      }
    }, {
      path: 'xqAll/:gjz/:date',
      component: () =>
        import("@/views/zxAll/xqAll"),
      name: 'xqAll',
      meta: {
        title: '需求项目',
        icon: '',
        rid: "-1",
        keepAlive: true
      }
    }, {
      path: 'gsAll/:gjz/:date',
      component: () =>
        import("@/views/zxAll/gsAll"),
      name: 'gsAll',
      meta: {
        title: '公示公告',
        icon: '',
        rid: "-1",
        keepAlive: true
      }
    }
    ]
  }, {
    path: '/notice',
    component: Layout,
    redirect: '/notice/notice',
    meta: {
      title: '通知公告',
      // icon: 'el-icon-setting',
      rid: ""
    },
    children: [{
      path: 'notice',
      component: () =>
        import("@/views/notice/notice"),
      name: 'notice',
      meta: {
        title: '通知公告',
        icon: '',
        rid: "-1"
      }
    },
    {
      path: 'handle',
      component: () =>
        import("@/views/notice/handle"),
      name: 'handle',
      meta: {
        title: '处置公告',
        icon: '',
        rid: "-1"
      }
    }]
  }, {
    path: '/policy',
    component: Layout,
    redirect: '/policy/tdlz',
    meta: {
      title: '政策法规',
      // icon: 'el-icon-tickets',
      rid: ""
    },
    children: [{
      path: 'tdlz',
      component: () =>
        import("@/views/policy/tdlz"),
      name: 'tdlz',
      meta: {
        title: '相关法律',
        icon: '',
        rid: "-1"
      }
    },
    {
      path: 'jtjsyd',
      component: () =>
        import("@/views/policy/jtjsyd"),
      name: 'jtjsyd',
      meta: {
        title: '政策文件',
        icon: '',
        rid: "-1"
      }
    },
      // {
      //   path: 'szgl',
      //   component: () =>
      //     import("@/views/policy/szgl"),
      //   name: 'szgl',
      //   meta: {
      //     title: '三资管理',
      //     icon: '',
      //     rid: "-1"
      //   }
      // },
      // {
      //   path: 'dydk',
      //   component: () =>
      //     import("@/views/policy/dydk"),
      //   name: 'dydk',
      //   meta: {
      //     title: '抵押贷款',
      //     icon: '',
      //     rid: "-1"
      //   }
      // }
    ]
  }, {
    path: '/trade',
    component: Layout,
    redirect: '/trade/ssbf',
    meta: {
      title: '交易规则',
      // icon: 'el-icon-document',
      rid: ""
    },
    children: [{
      path: 'ssbf',
      component: () =>
        import("@/views/trade/ssbf"),
      name: 'ssbf',
      meta: {
        title: '实施办法',
        icon: '',
        rid: "-1"
      }
    },
    {
      path: 'jygz',
      component: () =>
        import("@/views/trade/jygz"),
      name: 'jygz',
      meta: {
        title: '交易规则',
        icon: '',
        rid: "-1"
      }
    },
    {
      path: 'jyzn',
      component: () =>
        import("@/views/trade/jyzn"),
      name: 'jyzn',
      meta: {
        title: '交易指南',
        icon: '',
        rid: "-1"
      }
    },
    {
      path: 'jylct',
      component: () =>
        import("@/views/trade/jylct"),
      name: 'jylct',
      meta: {
        title: '交易流程图',
        icon: '',
        rid: "-1"
      }
    }]
  },
  {
    path: '/jjdt',
    component: Layout,
    redirect: '/jjdt/jjdt',
    meta: {
      title: '电子竞价',
      // icon: 'el-icon-news',
      rid: ""
    },
    children: [{
      path: 'jjdt',
      component: () =>
        import("@/views/jjdt/jjdt"),
      name: 'jjdt',
      meta: {
        title: '电子竞价',
        icon: '',
        rid: "-1"
      }
    }]
  },

  {
    path: '/project',
    component: Layout,
    // redirect: '/project/zrxm',
    meta: {
      title: '交易项目',
      // icon: 'el-icon-news',
      rid: ""
    },
    hidden: true,
    children: [{
      path: 'zrxm1',
      component: () =>
        import("@/views/project/zrxm"),
      name: 'zrxm1',
      meta: {
        title: '农户承包土地经营权',
        icon: '',
        type: 1,
        rid: "-1"
      }
    },
    {
      path: 'zrxm2',
      component: () =>
        import("@/views/project/zrxm"),
      name: 'zrxm2',
      meta: {
        title: '农村集体资源性资产',
        icon: '',
        type: 2,
        rid: "-1"
      }
    },
    {
      path: 'zrxm3',
      component: () =>
        import("@/views/project/zrxm"),
      name: 'zrxm3',
      meta: {
        title: '农村经营性资产',
        icon: '',
        type: 3,
        rid: "-1"
      }
    },
    {
      path: 'zrxm4',
      component: () =>
        import("@/views/project/zrxm"),
      name: 'zrxm4',
      meta: {
        title: '集体林木资产处置',
        icon: '',
        type: 4,
        rid: "-1"
      }
    },
    {
      path: 'zrxm5',
      component: () =>
        import("@/views/project/zrxm"),
      name: 'zrxm5',
      meta: {
        title: '农业生产设施设备',
        icon: '',
        type: 5,
        rid: "-1"
      }
    },
    {
      path: 'zrxm6',
      component: () =>
        import("@/views/project/zrxm"),
      name: 'zrxm6',
      meta: {
        title: '小型水利设施',
        icon: '',
        type: 6,
        rid: "-1"
      }
    },
    {
      path: 'zrxm9',
      component: () =>
        import("@/views/project/zrxm"),
      name: 'zrxm9',
      meta: {
        title: '集体建设用地',
        icon: '',
        type: 9,
        rid: "-1"
      }
    },
    {
      path: 'zrxm7',
      component: () =>
        import("@/views/project/zrxm"),
      name: 'zrxm7',
      meta: {
        title: '农村小微工程',
        icon: '',
        type: 7,
        rid: "-1"
      }
    },
    {
      path: 'zrxm20',
      component: () =>
        import("@/views/project/zrxm"),
      name: 'zrxm20',
      meta: {
        title: '涉农项目',
        icon: '',
        type: 20,
        rid: "-1"
      }
    },
    {
      path: 'zrxm21',
      component: () =>
        import("@/views/project/zrxm"),
      name: 'zrxm21',
      meta: {
        title: '农村知识产权',
        icon: '',
        type: 21,
        rid: "-1"
      }
    },
    {
      path: 'zrxm22',
      component: () =>
        import("@/views/project/zrxm"),
      name: 'zrxm22',
      meta: {
        title: '其他',
        icon: '',
        type: 22,
        rid: "-1"
      }
    },
    {
      path: 'xqxm1',
      component: () =>
        import("@/views/project/xqxm"),
      name: 'xqxm1',
      meta: {
        title: '耕地',
        icon: '',
        type: 1,
        rid: "-1"
      }
    },
    {
      path: 'xqxm2',
      component: () =>
        import("@/views/project/xqxm"),
      name: 'xqxm2',
      meta: {
        title: '园地',
        icon: '',
        type: 2,
        rid: "-1"
      }
    },
    {
      path: 'xqxm3',
      component: () =>
        import("@/views/project/xqxm"),
      name: 'xqxm3',
      meta: {
        title: '养殖水面',
        icon: '',
        type: 3,
        rid: "-1"
      }
    },
    {
      path: 'xqxm4',
      component: () =>
        import("@/views/project/xqxm"),
      name: 'xqxm4',
      meta: {
        title: '农业用地',
        icon: '',
        type: 4,
        rid: "-1"
      }
    },
    {
      path: 'xqxm5',
      component: () =>
        import("@/views/project/xqxm"),
      name: 'xqxm5',
      meta: {
        title: '四荒地',
        icon: '',
        type: 5,
        rid: "-1"
      }
    },
    {
      path: 'xqxm6',
      component: () =>
        import("@/views/project/xqxm"),
      name: 'xqxm6',
      meta: {
        title: '林地',
        icon: '',
        type: 6,
        rid: "-1"
      }
    },
    {
      path: 'xqxm7',
      component: () =>
        import("@/views/project/xqxm"),
      name: 'xqxm7',
      meta: {
        title: '实物资产',
        icon: '',
        type: 7,
        rid: "-1"
      }
    },
    {
      path: 'xqxm8',
      component: () =>
        import("@/views/project/xqxm"),
      name: 'xqxm8',
      meta: {
        title: '产权股权',
        icon: '',
        type: 8,
        rid: "-1"
      }
    },
    {
      path: 'xqxm9',
      component: () =>
        import("@/views/project/xqxm"),
      name: 'xqxm9',
      meta: {
        title: '建设用地',
        icon: '',
        type: 9,
        rid: "-1"
      }
    },

    ]
  },
  {
    path: '/project',
    component: Layout,
    redirect: '/project/zrxm',
    meta: {
      title: '交易项目',
      // icon: 'el-icon-news',
      rid: ""
    },
    children: [{
      path: 'zrxm1',
      component: () =>
        import("@/views/project/zrxm"),
      name: 'zrxm',
      redirect: '/project/zrxm',
      meta: {
        title: '供应项目',
        icon: '',
        rid: "-1"
      }
    },
    {
      path: 'xqxm',
      component: () =>
        import("@/views/project/xqxm"),
      name: 'xqxm',
      redirect: '/project/xqxm1',
      meta: {
        title: '需求项目',
        icon: '',
        rid: "-1"
      }
    }]
  },
  {
    path: '/bid',
    component: Layout,
    redirect: '/bid/zbgs',
    meta: {
      title: '公示公告',
      // icon: 'el-icon-news',
      rid: ""
    },
    children: [
      {
        path: 'cjgs',
        component: () =>
          import("@/views/bid/cjgs"),
        name: 'cjgs',
        meta: {
          title: '成交公示',
          icon: '',
          rid: "-1"
        }
      },
      {
        path: 'jzgg',
        component: () =>
          import("@/views/bid/jzgg"),
        name: 'jzgg',
        meta: {
          title: '鉴证公告',
          icon: '',
          rid: "-1"
        }
      },
      {
        path: 'zbgs',
        component: () =>
          import("@/views/bid/zbgs"),
        name: 'zbgs',
        meta: {
          title: '招标公示',
          icon: '',
          rid: "-1"
        }
      },
      {
        path: 'zhongbgs',
        component: () =>
          import("@/views/bid/zhongbgs"),
        name: 'zhongbgs',
        meta: {
          title: '中标公示',
          icon: '',
          rid: "-1"
        }
      },
      {
        path: 'rzgg',
        component: () =>
          import("@/views/bid/rzgg"),
        name: 'rzgg',
        meta: {
          title: '融资公告',
          icon: '',
          rid: "-1"
        }
      },
      {
        path: 'zbDetail/:id/:titleRoute/:titleName',
        component: () =>
          import("@/views/allComponent/zbDetail"),
        name: 'zbDetail',
        hidden: true,
        meta: {
          title: '招标公示',
          icon: '',
          rid: "-1"
        }
      },
      {
        path: 'cjgsDetail/:id?/:titleRoute/:titleName',
        component: () =>
          import("@/views/allComponent/cjgsDetail"),
        name: 'cjgsDetail',
        hidden: true,
        meta: {
          title: '成交公示详情',
          icon: '',
          rid: "-1"
        }
      },
      {
        path: 'jzggDetail/:id?/:titleRoute/:titleName',
        component: () =>
          import("@/views/allComponent/jzggDetail"),
        name: 'jzggDetail',
        hidden: true,
        meta: {
          title: '鉴证公告详情',
          icon: '',
          rid: "-1"
        }
      },
      {
        path: 'zongbDetail/:id/:titleRoute/:titleName',
        component: () =>
          import("@/views/allComponent/zongbDetail"),
        name: 'zongbDetail',
        hidden: true,
        meta: {
          title: '中标公示',
          icon: '',
          rid: "-1"
        }
      },
      {
        path: 'rzggDetail/:data/:titleRoute/:titleName',
        component: () =>
          import("@/views/bid/rzggDetail"),
        name: "rzggDetail",
        hidden: true,
        meta: {
          title: "融资公告详情",
          icon: ''
        }
      }]
  },
  {
    path: '/allConponent',
    component: Layout,
    hidden: true,
    meta: {
      title: '详情',
    },
    children: [{
      path: 'detail/:id/:navbarId/:titleRoute/:titleName',
      component: () =>
        import("@/views/allComponent/detail"),
      name: 'detail',
      meta: {
        title: '详情',
        rid: "-1"
      }
    },
    {
      path: 'jydetail/:id/:typeid',
      component: () =>
        import("@/views/allComponent/jydetail"),
      name: 'jydetail',
      meta: {
        title: '交易详情',
        rid: "-1"
      }
    },
    {
      path: 'xqdetail/:id/:typeid',
      component: () =>
        import("@/views/allComponent/xqdetail"),
      name: 'xqdetail',
      meta: {
        title: '交易详情',
        rid: "-1"
      }
    }]
  }
  , {
    path: '/interact',
    component: Layout,
    redirect: '/interact/hdwd',
    meta: {
      title: '互动交流',
      // icon: 'el-icon-news',
      rid: ""
    },
    children: [{
      path: 'hdwd',
      component: () =>
        import("@/views/interact/hdwd"),
      name: 'hdwd',
      meta: {
        title: '互动问答',
        icon: '',
        rid: "-1"
      }
    },
    {
      path: 'cjwt',
      component: () =>
        import("@/views/interact/cjwt"),
      name: 'cjwt',
      meta: {
        title: '常见问题',
        icon: '',
        rid: "-1"
      }
    }]
  }, {
    path: '/data',
    component: Layout,
    redirect: '/data/jyl',
    meta: {
      title: '资料下载',
      // icon: 'el-icon-message',
      rid: ""
    },
    children: [{
      path: 'jyl',
      component: () =>
        import("@/views/data/jyl"),
      name: 'jyl',
      meta: {
        title: '交易类',
        icon: '',
        rid: "-1"
      }
    },
    {
      path: 'htl',
      component: () =>
        import("@/views/data/htl"),
      name: 'htl',
      meta: {
        title: '合同类',
        icon: '',
        rid: "-1"
      }
    },
    {
      path: 'ztbl',
      component: () =>
        import("@/views/data/ztbl"),
      name: 'ztbl',
      meta: {
        title: '招投标类',
        icon: '',
        rid: "-1"
      }
    },
    {
      path: 'jjl',
      component: () =>
        import("@/views/data/jjl"),
      name: 'jjl',
      meta: {
        title: '竞价类',
        icon: '',
        rid: "-1"
      }
    },
    {
      path: 'qt',
      component: () =>
        import("@/views/data/qt"),
      name: 'qt',
      meta: {
        title: '其他',
        icon: '',
        rid: "-1"
      }
    }]
  }, {
    path: '/contact',
    component: Layout,
    redirect: '/contact/jgjj',
    meta: {
      title: '关于我们',
      // icon: 'el-icon-phone-outline',
      rid: ""
    },
    children: [{
      path: 'jgjj',
      component: () =>
        import("@/views/contact/jgjj"),
      name: 'jgjj',
      meta: {
        title: '机构简介',
        icon: '',
        rid: "-1"
      }
    },
    {
      path: 'zjjg',
      component: () =>
        import("@/views/contact/zjjg"),
      name: 'zjjg',
      meta: {
        title: '组织架构',
        icon: '',
        rid: "-1"
      }
    },
    {
      path: 'lxwm',
      component: () =>
        import("@/views/contact/lxwm"),
      name: 'lxwm',
      meta: {
        title: '联系我们',
        icon: '',
        rid: "-1"
      }
    }]
  }
  ,
  {
    path: '/signUp',
    component: Layout,
    hidden: true,
    redirect: '/signUp/signUp',
    meta: {
      title: '报名',
      // icon: 'el-icon-news',
      rid: ""
    },
    children: [
      {
        path: 'signUp/:xmbh/:htname/:xzqh',
        component: () =>
          import("@/views/signUp/signUp"),
        name: 'signUp',
        meta: {
          title: '报名',
          icon: '',
          rid: "-1"
        }
      },
      {
        path: 'signLogin/:xmbh',
        component: () =>
          import("@/views/signUp/signLogin"),
        name: 'signLogin',
        meta: {
          title: '报名登录',
          icon: '',
          rid: "-1"
        }
      },
      {
        path: 'signUpDetail/:xmbh/:htname/:lx/:xzqh',
        component: () =>
          import("@/views/signUp/signUpDetail"),
        name: 'signUpDetail',
        meta: {
          title: '报名详情',
          icon: '',
          rid: "-1"
        }
      },
      {
        path: 'auctionDetail/:xmbh',
        component: () =>
          import("@/views/signUp/auctionDetail"),
        name: 'auctionDetail',
        meta: {
          title: '竞价详情',
          icon: '',
          rid: "-1"
        }
      },
      {
        path: 'auctionDetailcq/:xmbh',
        component: () =>
          import("@/views/signUp/auctionDetailcq"),
        name: 'auctionDetailcq',
        meta: {
          title: '竞价详情产权',
          icon: '',
          rid: "-1"
        }
      },
      {
        path: 'auctionDetailgq/:xmbh',
        component: () =>
          import("@/views/signUp/auctionDetailgq"),
        name: 'auctionDetailgq',
        meta: {
          title: '竞价详情股权',
          icon: '',
          rid: "-1"
        }
      },
      {
        path: 'jjxmXq/:id',
        component: () =>
          import("@/views/signUp/jjxmXq"),
        name: 'jjxmXq',
        meta: {
          title: '竞价详情',
          icon: '',
          rid: "-1"
        }
      },
      {
        path: 'gqjjxmXq/:id',
        component: () =>
          import("@/views/signUp/gqjjxmXq"),
        name: 'gqjjxmXq',
        meta: {
          title: '竞价详情',
          icon: '',
          rid: "-1"
        }
      }
    ]
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]
export default new Router({
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
})
export let asyncRouterMap = [{
  path: '*',
  redirect: '/404',
  hidden: true
}]



// WEBPACK FOOTER //
// ./src/router/index.js